export default function Variables() {
    return {
        app: 'invoices',
        view: 'invoiceList',
        filters: {
            allClients: true,
            from: '',
            to: '',
            client: null,
            clients: [],
        },
        xport: {
            enabled: false,
            loading: false,
            dates: [],
        },
    }
}
